import { defineField, defineType } from 'sanity'
import getPageInfo, { seoGroup } from '../../objects/pageInfo'
import { strongEmLink } from '../../../data/richText'

export default defineType({
  title: 'Vehicles',
  name: 'vehicles',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    defineField({
      title: 'Enable Landing Page?',
      name: 'isLanding',
      type: 'boolean',
      initialValue: false,
      group: 'content',
    }),
    defineField({
      name: 'title',
      title: 'Title',
      type: 'string',
      validation: (rule) => rule.required(),
      description: 'Used as h1 on /vehicles page.',
      hidden: ({ parent }) => !parent?.isLanding,
      group: 'content',
    }),
    defineField({
      name: 'description',
      title: 'Description',
      description: 'Shows on vehicle index pages',
      type: 'array',
      of: strongEmLink,
      group: 'content',
    }),
    defineField({
      name: 'subtitle',
      title: 'Sub Title',
      type: 'string',
      validation: (rule) => rule.required(),
      description: 'Used as h2 on /vehicles page.',
      hidden: ({ parent }) => !parent?.isLanding,
      group: 'content',
    }),
    defineField({
      ...getPageInfo({ path: '', lockCanonical: true }),
      hidden: ({ parent }) => !parent?.isLanding,
    }),
  ],
  preview: {
    select: {
      pageInfo: 'pageInfo',
    },
    prepare(selection) {
      const { title = 'New Page', description: subtitle = '' } =
        selection.pageInfo || {}
      return {
        title,
        subtitle,
      }
    },
  },
})